/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

export const MIN_TICK = BigInt("-887272");
export const MAX_TICK = BigInt("887272");
export const MIN_SQRT_RATIO = BigInt("4295128739");
export const MAX_SQRT_RATIO = BigInt(
  "1461446703485210103287273052203988822378723970342"
);
export const Q128 = BigInt("340282366920938463463374607431768211456");
export const U128_MAX = BigInt("340282366920938463463374607431768211455");
export const Q64 = BigInt("18446744073709551616");
export const Q32 = BigInt("4294967296");
export const Q96 = BigInt("79228162514264337593543950336");
export const Q160 = BigInt("1461501637330902918203684832716283019655932542976");
export const MAX_REWARDS = BigInt("3");
